export default "__VITE_ASSET__Cmt3W$Cm__"